import { TableContainer, Table, TableHead, TableRow, TableBody, Select, MenuItem, TableCell, IconButton, Button, withStyles } from '@material-ui/core'
import React, { Component } from 'react'
import DeleteOutlineIcon from '@material-ui/icons/DeleteOutline';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import { Tax, Unit } from '../../../../common/common.model';
import AddIcon from '@material-ui/icons/Add';
import { InvoiceItem } from './invoice.model';
import { showErrorSnackbar } from '../../../../common/common.service';


const StyledTableCell = withStyles((theme) => ({
    head: {
      backgroundColor:"#f0f0f0",
      border: "1px solid #e3e3e3",
    },
    body: {
      border: "1px solid #e3e3e3",
      color:"#112B42"
    },
}))(TableCell);


export default class ItemList extends Component<any, any> {
    constructor(props: any) {
        super(props);
    }

    addRow = () => {
        console.log(this.props)
        if(!this.props.items.length) {
            showErrorSnackbar(this.props.snackbar, 'There are no items to add. Please add some items!', true);
            return;
        }
        const newRows = [
            ...this.props.rows,
            new InvoiceItem({rowId: this.props.rows.length + 1, ...this.props.items[0].toJson()}),
        ]

        this.props.setState(newRows);
    }

    handleItemChange = (e: any) => {
        const newRows = this.props.rows.map((row: any) => {
            if(row.rowId == e.target.name) {
                const rowId = row.rowId;
                const item = this.props.items.find((i: any) => i.id === e.target.value)
                row = new InvoiceItem({...item, rowId });
                row.id = e.target.value;
                row.quantity = 1;
                row.amount = row.rate * row.quantity
            }
            return row;
        });

        this.props.setState(newRows);
    }

    handleInputChange = (e: any, field: string) => {
        const newRows = this.props.rows.map((row: any) => {
            if(row.rowId == e.target.name) {
                const inputValue = e.target.value || 0;
                row[field] = parseFloat(inputValue);
                row.amount = row.rate * row.quantity
            }
            return row;
        })

        this.props.setState(newRows);
    }

    handleGSTChange = (e: any) => {
        const newRows = this.props.rows.map((row: any) => {
            if(row.rowId == e.target.name) {
                row.tax = parseInt(e.target.value);
                row.amount = row.rate * row.quantity
            }
            return row;
        })

        this.props.setState(newRows);
    }

    handleUnitChange = (e: any) => {
        const newRows = this.props.rows.map((row: any) => {
            if(row.rowId == e.target.name) {
                row.unit = e.target.value;
            }
            return row;
        })

        this.props.setState(newRows);
    }

    handleDelete = (rowId: any) => {
        this.props.confirm({
            title: 'Heads Up,',
            description: 'Are your sure? Want to delete this Invoice Item?',
            cancellationText: 'No',
            confirmationText: 'Yes, Delete it!',
            dialogProps: {
              open: true,
              maxWidth: 'xs'
            }
          })
          .then(() => {
            const newRows = this.props.rows.filter((row: any) => row.rowId != rowId);
            this.props.setState(newRows);
          })
    }

    render() {
        const classes = this.props.classes;
        const items = this.props.items.map((item: any) => (
            <MenuItem key={item.id} value={item.id} style={{color:"#112B42"}}>{item.name}</MenuItem>
        ));
        return (
            <>
                <TableContainer style={{width:"100%", overflow:"hidden", marginTop:"50px" }}>
                    {
                        this.props.error
                        ?
                            <label htmlFor=""><span>Item list shouldn't be empty!</span></label>
                        :
                            null
                    }
                    <Table size="small" aria-label="customized table" style={{width:"100%", overflow:"hidden" }}>
                    <TableHead>
                        <TableRow>
                            <StyledTableCell style={{color:"#7F7F7F", width: 241}}>Item Details</StyledTableCell>
                            <StyledTableCell style={{color:"#7F7F7F", width: 220}}>HSN Code</StyledTableCell>
                            <StyledTableCell style={{color:"#7F7F7F", width: 180}}>Quantity</StyledTableCell>
                            <StyledTableCell style={{color:"#7F7F7F", width: 180}}>Unit</StyledTableCell>
                            <StyledTableCell style={{color:"#7F7F7F", width: 200}}>Rate</StyledTableCell>
                            <StyledTableCell style={{color:"#7F7F7F", width: 200}}>Tax</StyledTableCell>
                            <StyledTableCell align="right" style={{color:"#7F7F7F"}}>Amount</StyledTableCell>
                            <TableCell style={{width: 25}}></TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {this.props.rows.map((row: any, index: number) =>{
                            return (
                        <TableRow key={index}>
                            <StyledTableCell style={{width: 150}}>
                                <Select style={{width: 200}} onChange={this.handleItemChange} className={classes.itemdrop} name={ row.rowId.toString() } value={row.id} disableUnderline IconComponent={(props) => <ExpandMoreIcon {...props} />}>
                                    { items }
                                </Select>
                            </StyledTableCell>
                            <StyledTableCell>{row.hsnCode}</StyledTableCell>
                            <StyledTableCell style={{width: 150}}><input style={{width: '100%', border: 'none'}} onFocus={(e: any) => e.target.select()} name={row.rowId.toString()} onChange={(e) => this.handleInputChange(e, 'quantity')} value={row.quantity}/></StyledTableCell>
                            {/* <StyledTableCell>{row.quantity}</StyledTableCell> */}
                            {/* <StyledTableCell  style={{width: 75}}><input style={{width: 60, border: 'none'}} name={row.rowId.toString()} onChange={(e) => this.handleInputChange(e, 'unit')} value={row.unit}/></StyledTableCell> */}
                            <StyledTableCell>
                                <Select onChange={this.handleUnitChange} style={{width: '100%'}} className={classes.itemdrop} name={ row.rowId.toString() } value={row.unit} disableUnderline IconComponent={(props) => <ExpandMoreIcon {...props} />}>
                                    <MenuItem value={Unit.KG} style={{color:"#112B42"}}>{Unit.KG}</MenuItem>
                                    <MenuItem value={Unit.BAG} style={{color:"#112B42"}}>{Unit.BAG}</MenuItem>
                                </Select>
                            </StyledTableCell>
                            <StyledTableCell style={{width: 200, display: 'flex', height: 43.2, alignItems: 'center'}}><span>₹</span> <input type="number" style={{width: 200, border: 'none'}} onFocus={(e: any) => e.target.select()} name={row.rowId.toString()} onChange={(e) => this.handleInputChange(e, 'rate')} value={row.rate}/></StyledTableCell>
                            <StyledTableCell>
                                <Select onChange={this.handleGSTChange} style={{width: '100%'}} className={classes.itemdrop} name={ row.rowId.toString() } value={row.tax} disableUnderline IconComponent={(props) => <ExpandMoreIcon {...props} />}>
                                    <MenuItem value={Tax.GST0} style={{color:"#112B42"}}>{Tax.GST0} %</MenuItem>
                                    <MenuItem value={Tax.GST5} style={{color:"#112B42"}}>{Tax.GST5} %</MenuItem>
                                    <MenuItem value={Tax.GST18} style={{color:"#112B42"}}>{Tax.GST18} %</MenuItem>
                                </Select>
                            </StyledTableCell>
                            <StyledTableCell style={{width: 138}} align="right">₹ {row.amount}</StyledTableCell>
                            <TableCell className={classes.deletecell}>
                                <IconButton size="small" onClick={() => this.handleDelete(row.rowId)}>
                                    <DeleteOutlineIcon fontSize="small" />
                                </IconButton>
                            </TableCell>
                        </TableRow>
                        )})}
                    </TableBody>
                    </Table>
                </TableContainer>
                <Button style={{color:"#0079e4", marginTop:"6px", fontSize:"13px", fontWeight:"bold", textTransform: 'capitalize', marginLeft:"-5px"}} onClick={this.addRow}>
                    <AddIcon fontSize="small" style={{cursor:"pointer", paddingBottom:"3px"}}/> Add New Line Item
                </Button>
            </>
        )
    }
}
